import { AxiosError } from 'axios';

import { Interceptor } from 'app/api/interceptor/Interceptor';
import { ValidationException } from 'app/api/exception/ValidationException';
import { MapBuilder } from 'app/utils/MapBuilder';
import { OtpValidationException } from 'app/api/exception/OtpValidationException';
import { Exception } from 'app/api/exception/Exception';

export class ValidationErrorInterceptor implements Interceptor {
    private readonly THROW_BY_EXCEPTION_TYPE = MapBuilder.create<
        string,
        (exception: Exception) => void
    >()
        .value(ValidationException.NAME, this.throwValidationException)
        .value(OtpValidationException.NAME, this.throwOtpValidationException)
        .defaultValue(this.throwValidationException)
        .build();

    process(error: AxiosError): void {
        if (error.response.status === 422) {
            const exception = error.response.data as Exception;

            const newVar = this.THROW_BY_EXCEPTION_TYPE.get(exception.type);

            newVar(exception);
        }
    }

    private throwValidationException(exception: Exception) {
        const payload = exception as ValidationException;

        throw new ValidationException(
            payload.id,
            payload.type,
            payload.message,
            payload.errors,
        );
    }

    private throwOtpValidationException(exception: Exception) {
        const payload = exception as OtpValidationException;

        throw new OtpValidationException(
            payload.id,
            payload.type,
            payload.message,
            payload.confirmation,
        );
    }
}
